import axiosInstance from "../api/axiosInstance";

const UNLIMITED = 99999;


export const isActiveCustomer = (plan, renewalDate, price) => {
    if (!plan) {
      return { active: false, statusText: "No Active Plan", color: "gray" };
    }
  
    const renewal = new Date(renewalDate);
    const today = new Date();
  
    
  
    if (renewal >= today) {

      if (price == null || price === 0) {
        return { active: true, statusText: "Trial Active", color: "#F89942" }; // Separate color for free trials
      }
      else{
        return { active: true, statusText: `Active until ${renewal.toDateString()}`, color: "#52CD5E" };
      }
    }
  
    return { active: false, statusText: "Plan Expired", color: "#F24A40" };
  };
  

  export const getAllowedUsers = async (teamId, planId) => {
    try {
      const response = await axiosInstance.get(`/api/team-limits/users/${teamId}/${planId}`);
      return response.data.allowedUsers; 
    } catch (error) {
      console.error("Error fetching allowed users:", error);
      return null; 
    }
  };

  export const getAllowedProjects = async (teamId, planId) => {
    try {
      const response = await axiosInstance.get(`/api/team-limits/projects/${teamId}/${planId}`);
      
      if(response.data.allowedProjects === UNLIMITED){
        return "Unlimited";
      }
      return response.data.allowedProjects; 
    } catch (error) {
      console.error("Error fetching allowed projects:", error);
      return null; 
    }
  };